import React from 'react';
import styled from 'styled-components';
import logo from '../assets/images/logo.png';
import { useNavigate } from 'react-router-dom';

const FooterWrapper = styled.footer`
  background: #fff;
  color: #222;
  font-size: 0.98em;
  text-align: left;
  box-sizing: border-box;
  position: relative;
  min-height: 160px;
  width: 100vw;
  padding: 20px;
  padding-bottom: 100px;
  background: ${props => {
    if (props.primaryColor && props.secondaryColor) {
      return `linear-gradient(135deg, ${props.primaryColor} 0%, ${props.secondaryColor} 100%)`;
    }
    return props.theme.colors.primaryGradient;
  }};
  transition: background 0.3s ease;
`;

const LogoBox = styled.div`
  img {
    width: 120px;
    height: auto;
    display: block;
  }
`;

const Info = styled.div`
  line-height: 1.7;
  color: #fff;
  margin-bottom: 10px;
`;

const SubInfo = styled.div`
  line-height: 1.6;
  color: #fff;
  font-size: 0.97em;
  margin-bottom: 10px;
`;

const Copyright = styled.div`
  color: #fff;
  font-size: 0.95em;
  margin-top: 10px;
`;

const LoginBtn = styled.div`
    font-size: 0.92em;
    font-weight: 500;
    color: #222;
    text-align: center;
    margin-top: 10px;
    cursor: pointer;
    width: fit-content;
`;

const FooterImage = styled.img`
  width: 100%;
  max-width: 600px;
  height: auto;
  display: block;
  margin: 0 auto;
  border-radius: 8px;
`;

const FooterTextContainer = styled.div`
  margin-top: 20px;
`;

function Footer({ footer, logo, campaignSetting }) {
  const navigate = useNavigate();

  const customColors = campaignSetting?.site_settings?.custom_colors;
  
  // footer 데이터가 없으면 기본 푸터 표시
  if (!footer) {
    return (
      <FooterWrapper 
        primaryColor={customColors?.primary}
        secondaryColor={customColors?.secondary}
        accentColor={customColors?.accent}
      >
        <LogoBox>
          <img src={logo?.downloadURL} alt="로고" />
        </LogoBox>
        <Info>
          상호: 이지에너지 | 대표자: 민정기<br/>
          주소: 충청북도 청주시 흥덕구 직지대로837-1,2층
        </Info>
        <SubInfo>
          사업자등록번호: 127-73-00430<br/>
          담당자 연락처: 010-5311-1236
        </SubInfo>
        <LoginBtn onClick={() => navigate('/login')}>로그인</LoginBtn>
        <Copyright>
          © 이지에너지. All rights reserved.
        </Copyright>
      </FooterWrapper>
    );
  }

  // footer.type이 'text'이고 이미지가 없는 경우 텍스트 데이터 사용
  if (footer.type === 'text' && !footer.image) {
    return (
      <FooterWrapper 
        primaryColor={customColors?.primary}
        secondaryColor={customColors?.secondary}
        accentColor={customColors?.accent}
      >
        <LogoBox>
          <img src={logo?.downloadURL} alt="로고" />
        </LogoBox>
        <FooterTextContainer>
          <Info>
            상호: {footer.text.company_name} | 대표자: {footer.text.ceo_name}<br/>
            주소: {footer.text.address}
          </Info>
          <SubInfo>
            사업자등록번호: {footer.text.business_number}
          </SubInfo>
        </FooterTextContainer>
        <Copyright>
          © {footer.text.company_name}. All rights reserved.
        </Copyright>
      </FooterWrapper>
    );
  }

  // footer.image가 있는 경우 이미지 우선 사용
  if (footer.image) {
    return (
      <FooterWrapper 
        primaryColor={campaignSetting?.custom_colors?.primary}
        secondaryColor={campaignSetting?.custom_colors?.secondary}
        accentColor={campaignSetting?.custom_colors?.accent}
      >
        <LogoBox>
          <img src={logo?.downloadURL} alt="로고" />
        </LogoBox>
        <FooterImage src={footer.image.downloadURL} alt="푸터 이미지" />
        <Copyright>
          © {footer.text?.company_name || '이지에너지'}. All rights reserved.
        </Copyright>
      </FooterWrapper>
    );
  }

  // 기본 푸터 (fallback)
  return (
    <FooterWrapper 
      primaryColor={customColors?.primary}
      secondaryColor={customColors?.secondary}
      accentColor={customColors?.accent}
    >
      <LogoBox>
        <img src={logo?.downloadURL} alt="로고" />
      </LogoBox>
      <Info>
        상호: 이지에너지 | 대표자: 민정기<br/>
        주소: 충청북도 청주시 흥덕구 직지대로837-1,2층
      </Info>
      <SubInfo>
        사업자등록번호: 127-73-00430<br/>
        담당자 연락처: 010-5311-1236
      </SubInfo>
      <LoginBtn onClick={() => navigate('/login')}>로그인</LoginBtn>
      <Copyright>
        © 이지에너지. All rights reserved.
      </Copyright>
    </FooterWrapper>
  );
}

export default Footer; 